import request from '@/utilsCloud/request'
import port from './port'

// 门户公告提醒
export function homeNotice() {
  return request({
    url: port.biz + '/enterprise/homeNotice',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: {}
  })
}
// 看课公告提醒
export function noticeInLearning() {
  return request({
    url: port.biz + '/enterprise/noticeInLearning',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: {}
  })
}


// WEBPACK FOOTER //
// ./src/apiCloud/noticeBox.js